import { render, staticRenderFns } from "./promoDetailsItem.vue?vue&type=template&id=570f8ad6&scoped=true"
import script from "./promoDetailsItem.vue?vue&type=script&lang=js"
export * from "./promoDetailsItem.vue?vue&type=script&lang=js"
import style0 from "./promoDetailsItem.vue?vue&type=style&index=0&id=570f8ad6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f8ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570f8ad6')) {
      api.createRecord('570f8ad6', component.options)
    } else {
      api.reload('570f8ad6', component.options)
    }
    module.hot.accept("./promoDetailsItem.vue?vue&type=template&id=570f8ad6&scoped=true", function () {
      api.rerender('570f8ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promo/components/promoDetailsItem.vue"
export default component.exports